import { CssBaseline, ThemeProvider } from "@material-ui/core";
import { SnackbarProvider, useSnackbar } from "notistack";
import { FC, memo, ReactNode, useEffect } from "react";
import { areEqual, toast } from "../../libs/utils";
import { MessengerThemeLayoutType, MessengerThemeType } from "../../store/messenger/types";
import themeGenerator from "../../themes";
import { SnackbarComponent } from "../shared/snackbar";
import styles from "./styles.module.scss";
import { useSelector } from "react-redux";
import { ReducersType } from "../../store";
import { ConnectionStatusType } from "../../store/connection/types";
import i18next from "i18next";
import { ROUTE_MESSENGER } from "../../constants/routes";

type Props = {
  appTheme: MessengerThemeType;
  children: ReactNode;
};

const ConnectionHandlerComponent: FC = () => {
  const locale = i18next.language?.substring(0, 2);

  const { closeSnackbar } = useSnackbar();
  const connectionStatus = useSelector<ReducersType, ConnectionStatusType>((state) => state.connection.connectionStatus);
  const showToast = () => {
    toast(<span className={`${locale === "fa" ? styles.rtlLoading : styles.loading} ${styles.toast__container}`}>{i18next.t(`connection.${ConnectionStatusType.DISCONNECTED}`)}</span>, {
      persist: true,
    });
  };

  useEffect(() => {
    document.addEventListener("contextmenu", (e) => {
      if (!(e.target as HTMLTextAreaElement).matches("input, textarea, [contenteditable]")) {
        e.preventDefault();
      }
    });
    if (connectionStatus === ConnectionStatusType.DISCONNECTED && window.location.href.includes(ROUTE_MESSENGER)) {
      showToast();
    }
    if (connectionStatus === ConnectionStatusType.CONNECTED) {
      closeSnackbar();
    }
  }, [connectionStatus]);
  return <></>;
};

const LayoutComponent: FC<Props> = (props) => {
  const themeLayout = useSelector<ReducersType, MessengerThemeLayoutType>((state) => state.messenger.chatSettings.theme_layout);

  const isBoxed = () => themeLayout === MessengerThemeLayoutType.BOXED && Boolean(window.matchMedia("(min-width : 1200px)").matches);

  return (
    <ThemeProvider theme={themeGenerator(props.appTheme)}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3} className={styles.toast__container}>
        <div className={`h-100 ${styles.layout} ${isBoxed() && styles.container}`}>
          <SnackbarComponent />
          <ConnectionHandlerComponent />
          {isBoxed() && <div className={styles.bg} style={{ backgroundImage: `url(${require("../../assets/img/backgrounds/winter.svg").default})` }} />}
          {props.children}
        </div>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default memo(LayoutComponent, areEqual);
